import { render, staticRenderFns } from "./LineSeparator.vue?vue&type=template&id=5fb39e88&scoped=true&"
import script from "./LineSeparator.vue?vue&type=script&lang=js&"
export * from "./LineSeparator.vue?vue&type=script&lang=js&"
import style0 from "./LineSeparator.vue?vue&type=style&index=0&id=5fb39e88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb39e88",
  null
  
)

export default component.exports